import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

interface Product {
	productCode: number;
	productName: string;
	rateScheduleName: string;
	tdu: string;
}

@Component({
	selector: 'app-agent-add-service',
	templateUrl: './add-service-account-component.html',
	styleUrls: ['./add-service-account-component.css'],
	providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
})

export class AddServiceAccountComponent implements OnInit {

	/* Data Model */
	public esid: string;
	public products: Product[] = [];
	public selectedProduct: any;
	public billingAccountNumber: string;
	public serviceStartDate: Date;
	public bdmvi: boolean = false;
	public bdmviReason: string = 'IAL';

	/* UI Model */
	public Message: string;
	public ErrorMessage: string;
	public is_super_admin: boolean;
	private screen: string = 'add_service_account';
	public esidTooltip: string = "Your ESI ID Number, or Electric Service Identifier, is a number that is unique to your property address. Pronounced “Easy I.D.” it’s also known as an ESIID, ESI ID or ESI-ID.";

	public isStartDateToday = false;
	public maxDateService = new Date();
	public serviceStartUptoDays: any;
	public holidayDates;
	public today;
	public timeover: any;
	public myFilter;

	constructor(private sharedService: SharedService, private localStorageService: LocalStorageService, private datePipe: DatePipe)
	{
		this.sharedService.setHeaderTitle(this.screen);
		this.sharedService.IsTheSessionValid(this.screen, true);
	}

	ngOnInit() {
		this.is_super_admin = this.localStorageService.get('isSuperAdmin');
	}

	setBdmvi(event) {
		console.log('Changed BDMVI to ' + event);
		this.bdmvi = event;
	}

	/* Create a new Service Account / Enrollment for the BAN and EsiId */
	Enroll() {

		if (this.products.length <= 0) {
			this.ErrorMessage = "Please select a Product";
			return;
		}

		this.sharedService.setLoader(this.screen, true);
		this.ClearMessages();
		let selectedProduct: Product = this.products[this.products.findIndex(item => item.rateScheduleName === this.selectedProduct)];

		let enrollObject = {
			'token': this.localStorageService.get('agentToken'),
			'esi_id': this.esid,
			'BillingAccountNumber': this.billingAccountNumber,
			'service_start_date': this.serviceStartDate,
			'IsBdmvi': this.bdmvi,
			"ThreeDaysFree": false,
			'IsAddSA': true,
			'productCode': selectedProduct.productCode,
			'rateScheduleName': selectedProduct.rateScheduleName,
			indicator: this.bdmviReason === 'IAL' ? 'IA' : 'CR'
		};

		this.sharedService.addServiceAccount(enrollObject)
			.then(response => {
				this.Message = response.message;
				this.sharedService.setLoader(this.screen, false);

			}).catch((ex) => {
			var exception = ex;
			this.ErrorMessage = ex._body;
			this.sharedService.setLoader(this.screen, false);
		});
	}

	/* Get the list of available Products for the EsiId */
	GetProductsByEsiid() {

		if (!this.esid) {
			return;
		}

		this.ClearMessages();
		this.sharedService.setLoader(this.screen, true);
		this.products = [];
		this.selectedProduct = undefined;
		this.serviceStartDate = null;
		this.sharedService.validateEsiid(this.esid)
			.then(response => {
				if (response.status == 'success') {
					this.Message = response.message;

					this.sharedService.getProductsForEsiid(this.esid)
						.then(response => {
							this.Message = response.message;
							if (response.products.length !== 0) {
								this.products = response.products;
								this.sharedService.setLoader(this.screen, false);

								this.getCalendarsByTDU()
							}
						})
						.catch((ex) => {
							this.ErrorMessage = ex._body;
							this.sharedService.setLoader(this.screen, false);
						});
				}
				else {
					this.ErrorMessage = response.message;
					this.sharedService.setLoader(this.screen, false);
				}
			});
	}

	/* Clear user messages */
	ClearMessages() {
		this.Message = "";
		this.ErrorMessage = "";
	}

	/* Get Holiday Calendar by TDU */
	getCalendarsByTDU() {
		let selectedProduct: Product = this.products[0];

		this.sharedService.getHolidayList({ 'tdsp': selectedProduct.tdu.toUpperCase() })
		.then(res => {
			if (res.status === 'success') {
				this.holidayDates = res.calendar;
				this.today = res.today;
				this.timeover = res.timeover;
			} else {
				this.holidayDates = [];
			}
		});
		this.sharedService.getConfigConst()
		.then(res => {
			if (res.status === 'success') {
				this.serviceStartUptoDays = res.results[0]['serviceStartUptoDays'];
				let newDate = new Date();
				newDate.setDate(newDate.getDate() + (this.serviceStartUptoDays - 1));
				this.maxDateService = newDate;
			}
		});
		this.myFilter = (momentDate): boolean => {
			const d = momentDate.toDate();
			const day = d.getDay();
			const today = new Date();
			const calendar_date = this.datePipe.transform(d, 'yyyy-MM-dd');
			const today_date = this.datePipe.transform(today, 'yyyy-MM-dd');
			if (today_date === calendar_date) {
				this.isStartDateToday = true;
				if (today.getHours() >= 18) {
					return false;
				}
			} else {
				this.isStartDateToday = false;
			}
			if (this.holidayDates !== undefined) {
				for (let i = 0; i <= this.holidayDates.length - 1; i++) {
					const holiday_date = this.datePipe.transform(this.holidayDates[i]['event_date'], 'yyyy-MM-dd');
					if (calendar_date === holiday_date) {
						return false;
					}
				}
			}
			return true && day !== 0;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/add-service/add-service-account-component.ts